import { ref, reactive, toRefs } from 'vue';
import axios from 'axios';

const unit = reactive({
  unitDetails: {
    unitId: '',
    name: '',
    complexId: '',
    roomRateClass: '',
    capacity: '',
    complexName: '',
    doorCode: '',
    dssAccessible: false,
    wiFiName: '',
    wiFiPassword: '',
    notes: '',
    roomModels: [],
    mailboxNumber: '',
  },
});

const currentUnitId = ref();

export default function useUnit(id) {
  unit.unitId = id;

  const preProcessUnit = () => {
    unit.unitDetails.unitId = Number(unit.unitDetails.unitId);
    unit.unitDetails.complexId = Number(unit.unitDetails.complexId);
    unit.unitDetails.baths = Number(unit.unitDetails.baths);
    unit.unitDetails.capacity = Number(unit.unitDetails.capacity);
  };

  const createUnit = async () => {
    try {
      preProcessUnit();
      const response = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/units`, unit.unitDetails);

      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const fetchUnit = async (fetchedId) => {
    try {
      if (fetchedId === undefined || fetchedId === null) {
        return null;
      }
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Units/${fetchedId}`;
      const response = await axios.get(url);
      const { data } = response;
      if (data !== undefined || data !== null) {
        unit.unitDetails = data;
      }
      return data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const fetchUnitNames = async (complexId) => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/units/unitNames`;
      const response = await axios.get(url,
        {
          params: { complexId },
        });
      const { data } = response;

      return data;
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const getUnitsExport = async () => {
    try {
      const result = await axios.get(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/units/unitsExport`,
      );

      return result.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const updateUnit = async (updateId) => {
    try {
      preProcessUnit();
      const response = await axios.put(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/units/${updateId}`, unit.unitDetails);

      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const updateUnitWifiAndParking = async (updateId) => {
    try {
      const response = await axios.put(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/units/putWifiAndParking/${updateId}`, unit.unitDetails);

      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const resetCurrentUnitId = () => {
    currentUnitId.value = null;
  };

  const resetCurrentUnit = () => {
    resetCurrentUnitId();
    unit.unitDetails.unitId = '';
    unit.unitDetails.name = '';
    unit.unitDetails.complexId = '';
    unit.unitDetails.roomRateClass = '';
    unit.unitDetails.capacity = '';
    unit.unitDetails.complexName = '';
    unit.unitDetails.doorCode = '';
    unit.unitDetails.dssAccessible = false;
    unit.unitDetails.wiFiName = '';
    unit.unitDetails.wiFiPassword = '';
    unit.unitDetails.notes = '';
    unit.unitDetails.roomModels = [];
    unit.unitDetails.mailboxNumber = '';
  };

  return {
    ...toRefs(unit),
    createUnit,
    currentUnitId,
    fetchUnit,
    fetchUnitNames,
    getUnitsExport,
    resetCurrentUnit,
    resetCurrentUnitId,
    updateUnit,
    updateUnitWifiAndParking,
  };
}
